import React from 'react';
import { Navigate } from 'react-router-dom';
import { getWebAccessLevel, hasActiveSupportInstitutionSession, isWebAdmin, WEB_ACCESS } from '@/auth/webAccess';
import { readStoredUser } from '@/auth/saasSession';

export default function AuditorRoute({ children }) {
  const user = readStoredUser();
  return (isWebAdmin(user) || getWebAccessLevel(user) === WEB_ACCESS.AUDITOR || hasActiveSupportInstitutionSession(user))
    ? children
    : <Navigate to="/dashboard" replace />;
}
